import { Box, useTheme } from '@mui/material'
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'
import { ParsedEarningsAndOrdersData } from '../types/Sale'

const sortGraphData = (data: ParsedEarningsAndOrdersData) => {
  const sortedOrdersData = [...data.ordersData].sort((a, b) => {
    const aParam = new Date(a.start_at) as unknown as number
    const bParam = new Date(b.start_at) as unknown as number

    return aParam - bParam
  })

  return sortedOrdersData
}

type Props = {
  graphData: ParsedEarningsAndOrdersData
}

const ItemsSoldGraph = ({ graphData }: Props) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        width: '100%',
        height: '400px',
        bgcolor: theme.palette.background.paper,
        px: 3,
        pt: 2,
        pb: 8
      }}
    >
      <ResponsiveContainer
        width="100%"
        height="100%"
        style={{ fontSize: '12px' }}
      >
        <AreaChart width={500} height={400} data={sortGraphData(graphData)}>
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop
                offset="5%"
                stopColor={theme.palette.primary.main}
                stopOpacity={0.8}
              />
              <stop
                offset="95%"
                stopColor={theme.palette.primary.main}
                stopOpacity={0}
              />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            interval="preserveStart"
            dataKey="start_at"
            tickFormatter={(date) =>
              new Date(date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short'
              })
            }
          />
          <YAxis dataKey="net_count" />
          <Tooltip
            labelFormatter={(date) =>
              new Date(date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
              })
            }
            labelStyle={{ color: theme.palette.primary.main }}
          />
          <Legend />
          <Area
            name="Items Sold"
            type="monotone"
            dataKey="net_count"
            stroke={theme.palette.primary.main}
            fill="url(#colorUv)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  )
}

export { ItemsSoldGraph }
